import React from 'react'

const Error = () => {
  return (
    <div>
      <h3>404! module not found.</h3>
    </div>
  )
}

export default Error
